import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Rect {
    x: number;
    y: number;
    width: number;
    height: number;
}

interface ResumePipState {
    rect: Rect;
    minimized: boolean;
    setRect: (rect: Rect) => void;
    setMinimized: (minimized: boolean) => void;
}

const getInitialRect = (): Rect => {
    const vw = typeof window !== 'undefined' ? window.innerWidth : 1200;
    const vh = typeof window !== 'undefined' ? window.innerHeight : 800;
    const height = Math.round(vh * 0.7);
    const width = Math.round(height * (8.5 / 11));
    return {
        x: Math.max(20, vw - width - 32),
        y: Math.max(20, Math.round((vh - height) / 2.5)),
        width,
        height,
    };
};

const useResumePipStore = create<ResumePipState>()(
    persist(
        (set) => ({
            rect: getInitialRect(),
            minimized: false,
            setRect: (rect) => set({ rect }),
            setMinimized: (minimized) => set({ minimized }),
        }),
        {
            name: 'lantern.resumePip/v1',
            partialize: (state) => ({ rect: state.rect, minimized: state.minimized }),
        },
    ),
);

export default useResumePipStore;
